<script setup lang="ts">
import SiteHeader from '@components/layout/site-header';
import SiteFooter from '@components/layout/site-footer';
import useExtraScript from '@composable/useExtraScript';
defineProps<{ showDrawer?: boolean }>();
const { isMrbilit } = useWhiteLabel();
useExtraScript();
</script>

<template>
    <div>
        <SiteHeader :show-drawer show-back class="site-header" />
        <slot />
        <SiteFooter />
        <VitePwaManifest v-if="isMrbilit" />
    </div>
</template>

<style lang="scss" scoped>
.hide-header-in-mobile {
    @include mobile-only {
        .site-header :deep(header) {
            display: none;
        }
    }
}
</style>
